module.exports = __webpack_public_path__ + "resource/img/a2.65b83bd6.jpg";